import React, {useEffect, useState} from 'react';
import {PanelWrapper, ShiftCard} from "../../../components";
import {SortByItem, SortByLists} from "../../../core-ui/sort-list/sort-list";
import {Card, CardAction} from "../../../core-ui/card/card";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {ShapeEndTimm, ShapeStartTimm} from "../../../core-ui/shapes/shapes";
import {fetchData, separatePriceFormat} from "../../../helpers/general-function";
import moment from "moment-jalaali";
import fa from "moment/locale/fa";
import {Modal} from "react-responsive-modal";
import {ShiftModalContainer} from "../../Requests/requests.styles";
import Notification from "../../../helpers/notifications";
import MobileSort from "../../../components/mobile-sort/mobile-sort";
import {CustomSheet, MobileSortItem} from "../../../components/mobile-sort-item/mobile-sort-item.styles";
import Sheet from "react-modal-sheet";

moment.locale("fa", fa);
moment.loadPersian({dialect: 'persian-modern'});

const SHIFT_ORDERS = [
    {name: 'درخواست های باز', order: 'pending'},
    {name: 'درخواست های انجام شده', order: 'completed'},
    {name: 'درخواست های انجام نشده', order: 'canceled'},
    {name: 'همه درخواست ها', order: 'all'},
];

const MyRequests = () => {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const [shiftRequests, setShiftRequests] = useState([]);
    const [activeOrder, setActiveOrder] = useState('pending');
    const [cancelModal, setCancelModal] = useState(null);
    const [mobileSortModal, setMobileSortModal] = useState(false);

    useEffect(() => {
        (async () => {
            const order = searchParams.get('order');

            if (!order) {
                navigate('/panel/my-shifts?order=pending');
                return false;
            }

            const data = await fetchData('panel/shift-requests', 'get', {offset: '0', limit: '10', order}, true);
            if (data) {
                setShiftRequests(data.shift_requests);
                setActiveOrder(order);
                if(mobileSortModal) {
                    setMobileSortModal(false)
                }
            }
        })()

    }, [searchParams]);

    const cancelShift = async () => {
        const {id} = cancelModal;

        const data = await fetchData(`panel/shift-requests/cancel/${id}`, 'get', {}, true);
        if(data) {
            setCancelModal(null);
            Notification.warning('شیفت مورد نظر لغو شد');
        }
    }

    return (
        <>
            <PanelWrapper activeRouteData={{icon: 'icon-clipboard-tick-2', name: 'شیفت های قبول شده'}}>
                <MobileSort clickHandler={() => setMobileSortModal(true)}
                            itemClassName='px-0'
                            title='فیلتر کردن بر اساس:'
                            sortName={SHIFT_ORDERS.find(item => item.order === activeOrder).name}/>

                <div className='d-none d-lg-flex'>
                    <div className='d-flex align-items-center'>
                        <i className='icon-document-filter ms-2'/>
                        <p className='mb-0 dark-gray'>فیلتر کردن بر اساس:</p>
                        <SortByLists>
                            {
                                SHIFT_ORDERS.map((item, index) => (
                                    <SortByItem className={item.order === activeOrder ? 'active-sort' : ''} key={index}>
                                        <Link to={`/panel/my-shifts?order=${item.order}`}>{item.name}</Link>
                                    </SortByItem>
                                ))
                            }
                        </SortByLists>
                    </div>
                </div>
                <div className='mt-5'>
                    <div className='row'>

                        {
                            shiftRequests.map(item => (
                                <div className='col-12 col-md-6' key={item.id}>
                                    <Card className={item.employed === '0' ? '' : 'c-border-accent-success'}>
                                        <p><i className='icon-hospital align-middle ms-3 ms-md-2'/>{item.shift.pharmacy.name}</p>
                                        <p><i className='icon-location align-middle ms-3 ms-md-2'/>{item.shift.pharmacy.address}</p>
                                        <p className='mt-c-2'><i className='icon-dollar-square align-middle ms-3 ms-md-2 icon-success'/>حق الزحمه
                                            شیفت: {separatePriceFormat(item.shift_time.earning)}</p>
                                        <p><i className='icon-calendar align-middle ms-3 ms-md-2 icon-success'/>تاریخ پرداخت
                                            حق‌الزحمه: {`${moment(item.shift_time.settlement_date, 'YYYY-MM-DD').format('dddd jYYYY/jMM/jDD')}`}
                                        </p>
                                        <div className='mt-c-2 d-flex'>
                                            <div className='d-flex flex-column justify-content-between my-1 ms-3 ms-md-2'>
                                                <ShapeStartTimm/>
                                                <div className='bottom-dashed-vertical flex-grow-1 ms-2'/>
                                                <ShapeEndTimm/>
                                            </div>
                                            <div>
                                                <p>{`${moment(item.shift_time.from, 'YYYY-MM-DD HH:mm:ss').format('از dddd jYYYY/jMM/jDD ساعت HH:mm:ss')}`}</p>
                                                <p className='mb-0'>{`${moment(item.shift_time.to, 'YYYY-MM-DD HH:mm:ss').format('تا dddd jYYYY/jMM/jDD ساعت HH:mm:ss')}`}</p>
                                            </div>
                                        </div>
                                        <div className='d-flex d-md-block mt-4 text-md-center'>
                                            {
                                                item.employed === '0' ?
                                                    <p className='success-color me-4 me-md-0'>درخواست در انتظار تایید از سمت کارفرما
                                                        است</p>
                                                    :
                                                    <p className='accent-success-color'>
                                                        <i className='icon-tick-square d-md-none align-middle mt-1 ms-3' />
                                                        <span>درخواست شما از سمت کارفرما تایید شده است</span>
                                                    </p>
                                            }

                                        </div>
                                        <CardAction>
                                            <div>
                                                <Link to={`/panel/my-shift-info/${item.id}`} className='sky-color'>اطلاعات
                                                    کارفرما</Link>
                                            </div>
                                            <div>
                                                {
                                                    item.cancellable ?
                                                        <button className='btn-text danger-color'
                                                                onClick={() => setCancelModal({
                                                                    name: item.shift.pharmacy.name,
                                                                    id: item.id
                                                                })}>لغو شیفت
                                                        </button> :
                                                        <p className='btn-text danger-color mb-0 cursor-not-allowed'
                                                           style={{opacity: '.6'}}>لغو شیفت</p>
                                                }

                                            </div>
                                        </CardAction>
                                    </Card>
                                </div>
                            ))
                        }

                    </div>
                </div>
            </PanelWrapper>

            <Modal open={!!cancelModal} onClose={() => setCancelModal(null)}
                   classNames={{modal: 'c-modal-container'}}
                   showCloseIcon={false} center>
                <ShiftModalContainer>
                        <div className='text-center mt-3 mt-c-lg-2_5'>
                            <p className='dark-danger-color mb-4 fs-c-3'>لغو شیفت برای {cancelModal?.name}</p>
                            <p className='gray-color fs-c-4 mb-c-4'>آیا از لغو ارسال درخواستتان به
                                شیفت {cancelModal?.name} اطمینان دارید؟</p>
                            <div className='d-flex align-items-center justify-content-center mb-4'>
                                <button className='btn-text dark-gray' onClick={() => setCancelModal(null)}>بازگشت به صفحه قبلی</button>
                                <button className='c-btn simple-btn-danger px-3 ms-5' onClick={cancelShift}>لغو درخواست ارسال شده</button>
                            </div>
                        </div>
                </ShiftModalContainer>
            </Modal>

            <CustomSheet isOpen={mobileSortModal} onClose={() => setMobileSortModal(false)}
                         snapPoints={[.7, 0.5, 100, 0]}>
                <Sheet.Container>
                    <Sheet.Header>
                        <div className='d-flex align-items-center justify-content-center px-2 py-3 rtl'>
                            <button className='btn-text ms-auto pt-2' onClick={() => setMobileSortModal(false)}>
                                <i className='icon-close-circle' />
                            </button>
                            <p className='dark-gray mb-0 flex-grow-1 text-center ms-5'>فیلتر کردن بر اساس</p>
                        </div>
                    </Sheet.Header>

                    <Sheet.Content>
                        <ul className='l-s-t-none mt-3 mb-0 p-0'>
                            {
                                SHIFT_ORDERS.map((item, index) => (
                                    <MobileSortItem className={activeOrder === item.order ? 'active-sort' : ''} key={index}>
                                        <Link to={`/panel/my-shifts?order=${item.order}`}>{item.name}</Link>
                                        {
                                            activeOrder === item.order &&
                                            <i className='icon-tick-circle tick' />
                                        }
                                    </MobileSortItem>
                                ))
                            }
                        </ul>
                    </Sheet.Content>
                </Sheet.Container>

                <Sheet.Backdrop />
            </CustomSheet>
        </>
    );
};

export default MyRequests;
